module.exports = __webpack_public_path__ + "img/11069869_L.327b2946.png";